<template>
  <div
    v-if="options"
    class="koc-partial koc-form-select-partial"
  >
    <div class="koc-dropdown">
      <div class="koc-input-content">
        <input
          :autocomplete="autocomplete"
          :name="name"
          :placeholder="placeholder"
          :value="
            state.selected
              ? state.selected.name || state.selected.label
              : state.filter
          "
          class="koc-input"
          type="text"
          @blur="exit()"
          @click="toggleOptionsDisplay($event)"
          @focus="focus()"
          @keyup="filter($event)"
        >
        <label
          :for="name"
          class="koc-label"
        >{{ label }}</label>
      </div>
      <div
        v-show="state.optionsShown"
        class="koc-dropdown-content"
      >
        <div
          v-if="'Categories' === label"
          class="koc-dropdown-item"
          @mousedown="clear('category')"
        >
          View All
        </div>
        <div
          v-for="(option, index) in state.filtered"
          :key="index"
          class="koc-dropdown-item"
          @mousedown="select(option)"
        >
          {{ option.name || option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./form-select-region-country.js"></script>
<style lang="scss" scoped src="./form-select-region-country.scss"></style>
